import React, { ReactElement, useContext, useEffect, useState } from 'react'

import { Card, Col, Row } from 'antd'
import moment from 'moment'
import { Scrollbars } from 'react-custom-scrollbars'

import { IHorario } from '../../../Models/docas'
import { DocasContext } from '../Context/context'
import CardAgendamento from './CardAgendamento'
interface TabPanelProps {
  cdJanela: number
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

const Janela = ({ cdJanela, atualizaAgenda }: TabPanelProps): ReactElement => {
  const { docasContext } = useContext(DocasContext)
  const [horarios, setHorarios] = useState<IHorario[]>([])
  const [janelaMovel, setJanelaMovel] = useState(window.innerWidth - 136)

  useEffect(() => {
    window.addEventListener('resize', () => {
      setJanelaMovel(window.innerWidth - 155)
    })

    return () => {
      window.removeEventListener('resize', () => void 0)
    }
  }, [])

  useEffect(() => {
    if (docasContext.horarios) {
      const horariosAux: IHorario[] = []
      docasContext.horarios
        ?.filter((x) => x.cdAgendamentoDocasJanela === cdJanela)
        .map((item: IHorario) => {
          if (horariosAux.filter((x) => x.hora === item.hora).length === 0) {
            horariosAux.push(item)
          }
        })
      setHorarios(horariosAux)
    }
  }, [docasContext.horarios])

  return (
    <>
      {docasContext?.dataAtual && (
        <>
          <div
            style={{
              maxHeight: '500px',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            <Row justify="start" wrap={false}>
              <Col flex="100px" style={{}}>
                <Row align="middle" justify="center">
                  <Card id="docas" className="card-agenda-data">
                    Docas
                    {/* {moment(docasContext.dataAtual).format('DD/MM/yyyy')} */}
                  </Card>
                </Row>
                {docasContext.armazemAtual?.agendamentoDocasDocas?.map(
                  (doca) => {
                    return (
                      <Row
                        align="middle"
                        key={`row_${doca.cdAgendamentoDocasDocas}_${doca.agendamentoDocasHorarios}`}
                        className={`row_${doca.cdAgendamentoDocasDocas}_${doca.agendamentoDocasHorarios}`}
                      >
                        <Card
                          id={`doca${doca.cdAgendamentoDocasDocas}`}
                          className="card-doca-nome"
                        >
                          {doca.nomeDoca}
                        </Card>
                      </Row>
                    )
                  },
                )}
              </Col>
              <Col>
                <Scrollbars
                  style={{
                    width: `${janelaMovel}px`,
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    paddingBottom: '30px',
                  }}
                >
                  <Row justify="start" wrap={false} style={{}}>
                    {horarios.map((horario: IHorario) => (
                      <Card
                        id={`horario${horario.cdAgendamentoDocasHorario}`}
                        style={{
                          minWidth: '380px',
                          width: `${janelaMovel / horarios.length}px`,
                        }}
                        key={`col_${horario.cdAgendamentoDocasHorario}`}
                        className={`doca-agenda-header ${
                          new Date().getHours().toString() ===
                          horario.hora.split(':')[0]
                            ? 'is-now'
                            : ''
                        }`}
                      >
                        {`${horario.hora.split(':')[0]}:${
                          horario.hora.split(':')[1]
                        }`}
                      </Card>
                    ))}
                  </Row>
                  {docasContext.armazemAtual?.agendamentoDocasDocas?.map(
                    (doca) => {
                      return (
                        <Row
                          justify="start"
                          wrap={false}
                          key={`row_${doca.cdAgendamentoDocasDocas}_${doca.agendamentoDocasHorarios}`}
                          className={`row_${doca.cdAgendamentoDocasDocas}_${doca.agendamentoDocasHorarios}`}
                        >
                          {docasContext.horarios
                            ?.filter(
                              (x) =>
                                x.cdAgendamendoDocasDocas ===
                                  doca.cdAgendamentoDocasDocas &&
                                x.cdAgendamentoDocasJanela === cdJanela,
                            )
                            .map((horario: IHorario) => {
                              return (
                                <Col
                                  style={{
                                    minWidth: '380px',
                                    width: `${janelaMovel / horarios.length}px`,
                                    margin: '2px 3px',
                                  }}
                                  flex="auto"
                                  className={`agendaCell  ${
                                    new Date().getHours().toString() ===
                                    horario.hora.split(':')[0]
                                      ? 'is-now'
                                      : ''
                                  }`}
                                  key={`cell__${horario.cdAgendamentoDocasHorario}`}
                                >
                                  <CardAgendamento
                                    horario={horario}
                                    atualizaAgenda={atualizaAgenda}
                                  />
                                </Col>
                              )
                            })}
                        </Row>
                      )
                    },
                  )}
                </Scrollbars>
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  )
}

export default Janela
